import { render, staticRenderFns } from "./IconPay.vue?vue&type=template&id=1e6fa881&"
import script from "./IconPay.vue?vue&type=script&lang=ts&"
export * from "./IconPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports